<section [ngClass]="['py-8 px-4', className]">
  <div class="container mx-auto">
    <div class="flex flex-col items-center justify-center">
      <div class="max-w-full">
        <div class="mx-auto mb-3 max-w-sm hyphens-auto break-words text-center">
          @switch (titleHtmlElement) { @case ('h1') {
          <h1
            class="mb-3 text-4xl font-bold"
            [attr.data-testid]="pageTitleH1TestId"
          >
            {{sectionTitle}}
          </h1>
          } @case ('h2') {
          <h2 class="mb-3 text-2xl font-semibold">{{sectionTitle}}</h2>
          } @case ('h3') {
          <h3 class="mb-3 text-xl font-semibold">{{sectionTitle}}</h3>
          } }
          <p class="mb-3 text-xl" [attr.data-testid]="pageSubTitleTestId">
            {{sectionSubtitle}}
          </p>
          @if (emojis) {
          <!-- We currently get a misleading warning from Angular which should be ignored.
          https://github.com/angular/angular/issues/56471  -->
          <div class="mt-6 flex items-center justify-center gap-3">
            @for (emoji of emojis; track emoji) {
            <pax-emoji [character]="emoji" />
            }
          </div>
          }
        </div>
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</section>
